var MAX_IMAGES_COUNT = 6;
var isPrimarySet = false;
var primaryImgContainer;
var primaryFromOld;
var PRIMARY_INDEX;
var imgWidth = 300;
var imgHeight = 300;
var removedImages = [];
$(document).ready(function(){
    primaryImgContainer = $('#primaryEdit');
    //if ($(' '))
});
function selectPrimary(imgObject){

    primaryFromOld = false;
    isPrimarySet = false;
    var jFilerItem = imgObject.parents('li.jFiler-item');
    $('#primary_finalView').hide();
    $('#help1').hide();
    var filerKit = $("#filer_input").prop("jFiler");
    $('.jFiler-item').removeClass('active');
    jFilerItem.addClass('active');
    var reader = new FileReader();
    reader.onload = function (e) {
        primaryImgContainer.attr('src', e.target.result);
        primaryImgContainer.cropper("destroy");
        $('#cropper-container').show();
        primaryImgContainer.cropper({
            aspectRatio: imgWidth/imgHeight,
            viewMode: 1,
            minCropBoxWidth: 100,
            minCropBoxHeight: 100,
            preview: '#preview',
            crop: function(e) {
                CROP_X = e.x;
                CROP_Y = e.y;
                CROP_WIDTH = e.width;
                CROP_HEIGHT = e.height;
            }
        });
    };
    PRIMARY_INDEX = $('#images-container .jFiler-item').index(jFilerItem);
    reader.readAsDataURL(filerKit.files_list[PRIMARY_INDEX].file);
}
function removeOldImage(rmvBtn){
    removedImages.push(rmvBtn.parents('li').data('imageid'))
    rmvBtn.parents('li').detach();
    $("#filer_input").prop("jFiler").options.limit++;
}
function selectPrimaryFromOld(imgObject){
    primaryFromOld = true;
    isPrimarySet = false;
    var jFilerItem = imgObject.parents('li.jFiler-item');
    $('#primary_finalView').hide();
    $('#help1').hide();
    PRIMARY_INDEX = jFilerItem.data('imageid');
    $('.jFiler-item').removeClass('active');
    jFilerItem.addClass('active');
    primaryImgContainer.attr('src', imgObject.find('img').attr('src'));
    primaryImgContainer.cropper("destroy");
    $('#cropper-container').show();
    primaryImgContainer.cropper({
        aspectRatio: imgWidth/imgHeight,
        viewMode: 1,
        minCropBoxWidth: 100,
        minCropBoxHeight: 100,
        preview: '#preview',
        crop: function(e) {
            CROP_X = e.x;
            CROP_Y = e.y;
            CROP_WIDTH = e.width;
            CROP_HEIGHT = e.height;
        }
    });
}
function setPrimary() {
    isPrimarySet = true;
    getResizedCanvas($('#primaryEdit').cropper('getCroppedCanvas'),imgWidth,imgHeight).toBlob(function (blob) {
        var reader = new FileReader();
        reader.onload = function (e) {
            $('#primary_finalView').attr('src', e.target.result);
            $('#cropper-container').hide();
            $('#primary_finalView').show();
            //var file = new File([blob], "primaryImage.jpg", {type: 'image/jpeg', lastModified: Date.now()});
            console.log($('#primary').val());
        };
        reader.readAsDataURL(blob);

        $('#primaryEdit').cropper('destroy');
    },'image/jpeg', 1);
}
function initFilerOptions(){
    filleroptions = {
        limit: MAX_IMAGES_COUNT - $('#old-images-container .jFiler-item').length,
        fileMaxSize: 5,
        extensions: ["jpg", "jpeg", "png", "gif"],
        //changeInput: '<div class="jFiler-input-dragDrop"><div class="jFiler-input-inner"><div class="jFiler-input-icon"><i class="icon-jfi-cloud-up-o"></i></div><div class="jFiler-input-text"><h3>Перетащите файлы сюда</h3> <span style="display:inline-block; margin: 15px 0">или</span></div><a class="jFiler-input-choose-btn blue">Открыть файлы</a></div></div>',
        changeInput: '<div class="jFiler-input-dragDrop"><div class="jFiler-input-inner"><div class="jFiler-input-icon"><i class="icon-jfi-cloud-up-o"></i></div><div class="jFiler-input-text"><h3>Перетащите фотографии в эту область</h3> <span style="display:inline-block; margin: 15px 0">или</span></div><a class="jFiler-input-choose-btn blue">Открыть файлы</a></div></div>',
        showThumbs: true,
        theme: "dragdropbox",
        templates: {
            box: '<ul class="jFiler-items-list jFiler-items-grid"></ul>',
            item: '<li class="jFiler-item">\
						<div class="jFiler-remove-btn"><span class="glyphicon glyphicon-remove"></span></div>\
						<div class="jFiler-item-container" onclick="selectPrimary($(this))">\
							<div class="jFiler-item-inner">\
								<div class="jFiler-item-thumb">\
									<div class="jFiler-item-status"></div>\
									<div class="jFiler-item-thumb-overlay">\
										<div class="jFiler-item-info">\
											<div style="display:table-cell;vertical-align: middle;">\
												<span class="jFiler-item-title"><b title="{{fi-name}}">{{fi-name}}</b></span>\
												<span class="jFiler-item-others">{{fi-size2}}</span>\
											</div>\
										</div>\
									</div>\
									{{fi-image}}\
								</div>\
								<div class="jFiler-item-assets jFiler-row">\
                                    {{fi-name}}\
								</div>\
							</div>\
						</div>\
					</li>',
            itemAppend: '<li class="jFiler-item">\
						<div class="jFiler-remove-btn"><span class="glyphicon glyphicon-remove"></span></div>\
							<div class="jFiler-item-container" onclick="selectPrimary($(this))">\
								<div class="jFiler-item-inner">\
									<div class="jFiler-item-thumb">\
										<div class="jFiler-item-status"></div>\
										<div class="jFiler-item-thumb-overlay">\
											<div class="jFiler-item-info">\
												<div style="display:table-cell;vertical-align: middle;">\
													<span class="jFiler-item-title"><b title="{{fi-name}}">{{fi-name}}</b></span>\
													<span class="jFiler-item-others">{{fi-size2}}</span>\
												</div>\
											</div>\
										</div>\
										{{fi-image}}\
									</div>\
                                    <div class="jFiler-item-assets jFiler-row">\
                                        {{fi-name}}\
                                    </div>\
								</div>\
							</div>\
						</li>',
            progressBar: '<div class="bar"></div>',
            itemAppendToEnd: true,
            canvasImage: true,
            removeConfirmation: false,
            _selectors: {
                list: '.jFiler-items-list',
                item: '.jFiler-item',
                progressBar: '.bar',
                remove: '.jFiler-remove-btn'
            }
        },
        appendTo: "#images-container",
        addMore: false,
        dragDrop: {
            dragEnter: null,
            dragLeave: null,
            drop: null,
            dragContainer: null,
        },
        uploadFile: {
            url: "#",
        },
        allowDuplicates: false,
        clipBoardPaste: true,
        onRemove: function (itemEl, file, id, listEl, boxEl, newInputEl, inputEl) {

        },
        dialogs: {
            alert: function (text) {
                return alert(text);
            },
            confirm: function (text, callback) {
                confirm(text) ? callback() : null;
            }
        },
        captions: {
            button: "Выберите файлы",
            feedback: "Выберите файлы для загрузки",
            feedback2: "выбранные файлы",
            drop: "Перетащите сюда файлы изображений",
            removeConfirmation: "Вы уверены, что хотите удалить изображение?",
            errors: {
                filesLimit: "Можно загрузить файлов не больше {{fi-limit}}.",
                filesType: "Загружать можно только изображения.",
                filesSize: "{{fi-name}} слишком большой! Загрузите файл размером не больше {{fi-maxSize}} МБ.",
                filesSizeAll: "Файлы, которые вы выбрали, слишком большие! Загрузите файлы размером не больше {{fi-maxSize}} МБ."
            }
        }
    }
}
